const globalStyles = {
    colors: {
        peach: '#ff7163',
        extraLightPeach: '#fff7f6',
        navyBlue: '#263b70',
        white: 'white',
    },
    spacing: {
        mobileSideSpacing: '15px',
        laptopSideSpacing: '50px',
        desktopSideSpacing: '100px',
        form: {
            mobileSideSpacing: '15px',
            laptopSideSpacing: '50px',
            desktopSideSpacing: '100px',
        }
    },
    devices: {
        small: '480px',
        tablet: '768px',
        laptop: '1024px',
        large: '1200px',
        xlarge: '1400px',
    },
    other: {
        navbarHeight: '80px'
    }
}

export default globalStyles